import { computed, watch } from "vue";
import { useStore } from "vuex"

export const useInitE1TaxCalculate = () => {
	const store = useStore();
	const basket = computed(() => store.getters.getBasket);
	const isBasketSet = computed(() => store.getters.getIsBasketSet);
	const e1TaxCalculate = computed(() => store.getters.getE1TaxCalculate);

	/**
	 * Is supposed to be called in the root of the app that is always mounted on page
	 * so that watcher remains active. It can be called in multiple apps - only one watcher will be set.
	 */
	const setE1TaxCalculateWatcher = () => {
		// we only need one global watcher set
		if (e1TaxCalculate.value.isCalculateWatcherInited) {
			return;
		}

		watch(basket, () => {
			if (isBasketSet.value) {
				store.dispatch('updateE1Tax');
			}
		}, {
			immediate: true,
		});

		store.commit('setE1TaxCalculate', {
			isCalculateWatcherInited: true,
		});
	}
	return {
		setE1TaxCalculateWatcher
	};
}